import React, { useEffect, useRef } from "react";
import Button from "../layout/Button";
import { ClearIcon } from "../Iconset";

export default function FullScreenImagePreview(props: { 
	assetSrc: string,
	onClose?: () => void,
})
{
	const rootRef = useRef<HTMLDivElement>(null);
	const canvasRef = useRef<HTMLCanvasElement>(null);

	const resolution = 1080;

	useEffect(() => 
	{
		const image = new Image();
		image.src = props.assetSrc;
		image.onload = () => 
		{
			if (!canvasRef?.current) return;
	
			const canvas = canvasRef.current;
			const context = canvas.getContext('2d');
			if (!context) return;
	
			// Clear the canvas and fill with black
			context.fillStyle = 'black';
			context.fillRect(0, 0, canvas.width, canvas.height);
	
			// Calculate aspect ratios
			const canvasRatio = canvas.width / canvas.height;
			const imageRatio = image.width / image.height;
	
			let drawWidth: number, drawHeight: number, drawX: number, drawY: number;
	
			// Compare aspect ratios to determine how to scale image
			if (imageRatio < canvasRatio) 
			{
				// Image is narrower than canvas (relative to their heights)
				drawHeight = canvas.height;
				drawWidth = image.width * (drawHeight / image.height);
				drawX = (canvas.width - drawWidth) / 2;
				drawY = 0;
			}
			else 
			{
				// Image is wider than canvas (relative to their widths)
				drawWidth = canvas.width;
				drawHeight = image.height * (drawWidth / image.width);
				drawX = 0;
				drawY = (canvas.height - drawHeight) / 2;
			}
	
			// Draw the image with calculated dimensions
			context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
	
			// Optional: Draw a border around the canvas
			context.globalCompositeOperation = "source-over";
			context.lineWidth = 5;
			context.strokeStyle = "#000000";
			context.strokeRect(0, 0, canvas.width, canvas.height);
		};
	}, [props.assetSrc]);

	return (
		<div ref={rootRef}
			data-name={"camera-preview-root"}
			className={"fullScreen"}
		>
			<canvas ref={canvasRef} 
				className={"fullScreen"}
				height={resolution}
				width={resolution * 1.6}
			/>
			<Button className={"fullScreenImageCloseButton"}
				data-name={"close-button"}
				onClick={()=>
				{
					if(props.onClose)
					{
						props.onClose();
					}
				}}
				iconRenderer={<ClearIcon scale={3.5}/>}
			/>
		</div>
	);
}